export interface B2CContenidoInterface {
    portalHtml: string;
    portalScript: string;
    portalStyle: string;
}

export class B2CContenido {
    constructor(
        public portalHtml: string,
        public portalScript: string,
        public portalStyle: string
    ) {
    }
}

export class B2CContenidoMaker {
    static createInterface(event: B2CContenidoInterface): B2CContenidoInterface {
        return { portalHtml: event.portalHtml, portalScript: event.portalScript, portalStyle: event.portalStyle }
    }

    static create(event: B2CContenido) {
        return new B2CContenido(event.portalHtml, event.portalScript, event.portalStyle);
    }
}